import "./styles.scss";

import Popup from "reactjs-popup";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { getContentLinkWithSequentialScheduleId, handleSelectColor } from "../../../utils/utils";

function CardNextClasses({ data, sequentialScheduleId }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const renderPopup = (value, max) => (
    <Popup
      on={"hover"}
      position={"top center"}
      style={{ width: 300, zIndex: 999999999, marginLeft: 20 }}
      trigger={<p className="descriptionContent">{value?.slice(0, max).concat("...")}</p>}
    >
      <div>
        <p>{value}</p>
      </div>
    </Popup>
  );

  return (
    <div className="contentCardNextClasses">
      <div className="rowContent">
        {user?.role === "student" && data?.linkForStudent && (
          <a
            target="_blank"
            rel="noreferrer"
            href={getContentLinkWithSequentialScheduleId(data?.linkForStudent, sequentialScheduleId)}
          >
            <span className="contentCode studentCode">{data?.contentCode}</span>
          </a>
        )}
        {user?.role !== "student" && data?.linkForTeacher && (
          <a
            target="_blank"
            rel="noreferrer"
            href={getContentLinkWithSequentialScheduleId(data?.linkForTeacher, sequentialScheduleId)}
          >
            <span className="contentCode">{data?.contentCode}</span>
          </a>
        )}

        {data?.focus?.toLowerCase() === "specific" && (
          <div className="rowContentSpecific">
            <span className="contentCode">{t("BTN_SPECIFIC")}</span>

            {data?.specificSubject && (
              <div>
                <label className="titleContent">{t("STUDENT_DESCRIPTION")}</label>
                <p className="descriptionContent">{data?.specificSubject}</p>
              </div>
            )}
          </div>
        )}

        {data?.classTitle && (
          <div className="columnItem">
            <span className="titleContent">{t("CLASS_TITLE")}</span>
            <span className="spanContent">{renderPopup(data?.classTitle, 9)}</span>
          </div>
        )}
        {data?.cycleName && (
          <div className="columnItem">
            <span className="titleContent">{t("CYCLE_NAME")}</span>
            <span className="spanContent">{renderPopup(data?.cycleName, 9)}</span>
          </div>
        )}
        {data?.level && (
          <div className="wrapperLevelAndCycle">
            <div className="columnItem">
              <span className={`level ${handleSelectColor(data?.level)}`}>
                {data?.level === "DEMO" ? "D" : data?.level}
              </span>
            </div>
            <div className="columnItem">
              <span className="titleContent">{t("CYCLE")}</span>
              <span className={`cicle ${handleSelectColor(data?.level)}`}>{data?.cycle}</span>
            </div>
          </div>
        )}
        {data?.contentExists ? (
          <div className="columnItem">
            <span className="titleContent">{t("CLASS_NOT_COMPLETED_CONTINUE")}</span>
            <span className="spanClassNotCompleted">{`Pag ${data?.contentExistsData[0]?.pageFinished} - ${data?.contentExistsData[0]?.continueComment}`}</span>
          </div>
        ) : (
          <div style={{ width: 170 }}></div>
        )}

        {user?.role !== "student" && data?.linkForStudent && (
          <a
            target="_blank"
            rel="noreferrer"
            href={getContentLinkWithSequentialScheduleId(data?.linkForStudent, sequentialScheduleId)}
          >
            <span className="contentCode studentCode">{data?.contentCode}</span>
          </a>
        )}
      </div>
    </div>
  );
}

export default CardNextClasses;
